/* ==========================================================================
   Himalaya Optical lens + prescription controller — Gem theme port
   --------------------------------------------------------------------------
   Differences from the Glassos original, and why:

   1. Form lookup. Glassos used `.product-form-{sectionId}`. Gem renders
      `#product-form-{sectionId}` inside a <block-buy-buttons> custom element.

   2. Submit interception. <block-buy-buttons> listens for `submit` in the
      BUBBLE phase on itself and runs its own ajax add. We attach in the
      CAPTURE phase on the form, which always runs first, and call
      stopImmediatePropagation() so Gem's handler never sees the event. If the
      configurator is not shown (sunglasses, audiology, lens add-on products),
      we never attach at all and Gem's normal flow is completely untouched.

   3. Product data. Glassos had #ProductJson-{sectionId}. The block emits its
      own [data-ho-product-json] blob instead.

   4. Variant changes. Gem dispatches `variant:change:{sectionId}:{productId}`.
      We listen for that plus a plain `change` on [name="id"] as a fallback.

   5. jQuery removed. The original loaded jQuery again just for a progress bar.
      Gem has no jQuery and does not need it.

   6. Powered sunglasses (2026-09). Approved-brand sunglasses load
      sunlens-add-on (Akrivistaa Powered Sun-lens). Standard Ray-Ban
      sunglasses load BOTH sunlens-add-on and rayban-sunlens-add-on
      (Ray-Ban Authentic Lens), with strict source ownership + dedupe.

   7. Buy it now. When the configurator is active, Shopify's dynamic checkout
      button is replaced by our own so the lens + prescription are never
      skipped. It clears the cart, adds the configured items and goes to
      checkout (same behaviour as the Himalaya Optical store).
   ========================================================================== */
(function () {
  'use strict'

  var CONFIG = window.HO_LENS_CONFIG
  if (!CONFIG) return

  var SECTION_ID = CONFIG.sectionId
  var MAX_CART_QTY = Number(CONFIG.maxCartQty || 10)
  var isSpecialLensBrand = CONFIG.isSpecialLensBrand === true
  var showLensSelector = CONFIG.showLensSelector === true
  var isContactLens = CONFIG.isContactLens === true
  var isSunLensProduct = CONFIG.isSunLens === true
  var isRayBanSunLensProduct = CONFIG.isRayBanSunLens === true
  var VALID_GROUPS = ['Frame Only', 'Single Vision', 'Progressive', 'Akrivistaa Powered Sunlens', 'Ray-Ban Authentic Lens']

  var LENS_ADDON_HANDLES = [
    'lens-add-on',
    'rimless-lens-add-on',
    'special-brand-lens-add-on',
    'rayban-meta-gen2-lens-add-on',
    'oakley-meta-clear-lens-add-on',
    'sunlens-add-on',
    'rayban-sunlens-add-on'
  ]

  var root = '/'
  if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
    root = window.Shopify.routes.root
  }

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn)
    else fn()
  }

  ready(function () {
    var form = document.getElementById('product-form-' + SECTION_ID)
    if (!form) return

    /* ------------------------------------------------------------ elements */

    var lensBox = document.querySelector('[data-ho-lens-box]')
    var lensSelect = document.querySelector('[data-ho-lens-select]')
    var lensTypeButtons = document.querySelectorAll('[data-ho-lens-group]')
    var lensChoiceWrap = document.querySelector('[data-ho-lens-choice-wrap]')
    var lensChoiceSelect = document.querySelector('[data-ho-lens-choice]')
    var lensChoiceLabel = document.querySelector('[data-ho-lens-choice-label]')
    var lensSummary = document.querySelector('[data-ho-lens-summary]')
    var lensPrice = document.querySelector('[data-ho-lens-price]')
    var rayBanDeliveryNotice = document.querySelector('[data-ho-rayban-delivery-notice]')

    var specialOfferPrice = document.querySelector('[data-ho-special-offer-price]')
    var specialOfferTitle = document.querySelector('[data-ho-special-offer-title]')
    var specialOfferCopy = document.querySelector('[data-ho-special-offer-copy]')

    var packageSummary = document.querySelector('[data-ho-package-summary]')
    var packageFramePrice = document.querySelector('[data-ho-package-frame-price]')
    var packageLensLabel = document.querySelector('[data-ho-package-lens-label]')
    var packageLensPrice = document.querySelector('[data-ho-package-lens-price]')
    var packageSaving = document.querySelector('[data-ho-package-saving]')
    var packageTotal = document.querySelector('[data-ho-package-total]')
    var packageNote = document.querySelector('[data-ho-package-note]')

    var cartNotice = document.querySelector('[data-ho-cart-notice]')
    var cartNoticeTitle = document.querySelector('[data-ho-cart-notice-title]')
    var cartNoticeCopy = document.querySelector('[data-ho-cart-notice-copy]')
    var cartNoticeClose = document.querySelector('[data-ho-cart-notice-close]')

    var lensFrameProperty = document.querySelector('[data-ho-lens-frame-property]')
    var powerRequirementProperty = document.querySelector('[data-ho-power-requirement-property]')
    var powerDetailsProperty = document.querySelector('[data-ho-power-details-property]')
    var powerWrapper = document.querySelector('[data-ho-power-wrapper]')
    var powerSelect = document.querySelector('[data-ho-power-select]')
    var powerHelp = document.querySelector('[data-ho-power-help]')
    var powerError = document.querySelector('[data-ho-power-error]')
    var powerStatus = document.querySelector('[data-ho-power-status]')
    var powerLabel = document.querySelector('[data-ho-power-label]')

    var addButton = document.getElementById('ProductSubmitButton-' + SECTION_ID)
    var quantityInput = form.querySelector('[name="quantity"]')

    var selectedLensGroup = 'Frame Only'
    var lensOptionsLoaded = false
    var lastLensRequirement = null
    var isNativeUploadSubmitting = false
    var goToCheckoutMode = false

    var lensProductHandle = lensBox
      ? lensBox.getAttribute('data-lens-product-handle') || 'lens-add-on'
      : 'lens-add-on'

    // Ray-Ban sunglasses need both add-on products; everything else uses one.
    var lensProductHandles = isRayBanSunLensProduct
      ? ['sunlens-add-on', 'rayban-sunlens-add-on']
      : [lensProductHandle]

    var productData = null
    try {
      var blob = document.querySelector('[data-ho-product-json]')
      if (blob) productData = JSON.parse(blob.textContent)
    } catch (e) {
      productData = null
    }

    /* ------------------------------------------------------------ helpers */

    function formatMoney(cents) {
      cents = Number(cents || 0)
      return '₹' + (cents / 100).toLocaleString('en-IN', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      })
    }

    function cleanText(v) {
      return String(v || '').replace(/\s+/g, ' ').trim()
    }

    function getLensSavings(lens) {
      if (!lens) return 0
      return Math.max(0, Number(lens.compareAtPrice || 0) - Number(lens.price || 0))
    }

    function getBaseProductLabel() {
      return isSunLensProduct ? 'Sunglass Only' : 'Frame Only'
    }

    function getDisplayLensGroupName(group) {
      return group === 'Akrivistaa Powered Sunlens' ? 'Akrivistaa Powered Sun-lens' : group
    }

    function getLensOfferText(lens) {
      if (!lens || !lens.variantId) return getBaseProductLabel()
      if (lens.price === 0) {
        return lens.compareAtPrice > 0 ? 'FREE · Regular ' + formatMoney(lens.compareAtPrice) : 'FREE'
      }
      if (lens.compareAtPrice > lens.price) {
        return 'Offer ' + formatMoney(lens.price) +
          ' · Regular ' + formatMoney(lens.compareAtPrice) +
          ' · Save ' + formatMoney(getLensSavings(lens))
      }
      return formatMoney(lens.price)
    }

    function getPrescriptionStatusText(method) {
      if (method === 'Upload Prescription') return 'Prescription uploaded with order'
      if (method === 'Manual Power') return 'Power entered on product page'
      return isSunLensProduct ? 'No sunglass power required' : 'No prescription supplied'
    }

    /* ------------------------------------------------------------- notices */

    function hideNotice() {
      if (!cartNotice) return
      cartNotice.classList.remove('is-visible')
      setTimeout(function () { cartNotice.hidden = true }, 230)
    }

    function showNotice(title, copy) {
      if (!cartNotice) return
      if (cartNoticeTitle) cartNoticeTitle.textContent = title || 'Lens selected'
      if (cartNoticeCopy) cartNoticeCopy.textContent = copy || ''
      cartNotice.hidden = false
      cartNotice.classList.remove('is-visible')
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { cartNotice.classList.add('is-visible') })
      })
    }

    if (cartNoticeClose) cartNoticeClose.addEventListener('click', hideNotice)

    function showLensSelectionNotice(lens) {
      if (!isSpecialLensBrand || selectedLensGroup === 'Frame Only' || !lens || !lens.variantId) {
        if (selectedLensGroup === 'Frame Only') hideNotice()
        return
      }

      if (lens.price === 0) {
        showNotice(
          'Complimentary lens selected',
          lens.compareAtPrice > 0
            ? 'You unlocked a ' + formatMoney(lens.compareAtPrice) + ' lens at ₹0 with this frame. Enter your power or upload your prescription.'
            : lens.type + ' is included at ₹0. Enter your power or upload your prescription.'
        )
        return
      }

      if (lens.compareAtPrice > lens.price) {
        showNotice(
          'Offer unlocked — ' + formatMoney(lens.compareAtPrice) + ' lens for ' + formatMoney(lens.price),
          'You save ' + formatMoney(getLensSavings(lens)) + '. Enter your power or upload your prescription.'
        )
        return
      }

      showNotice(
        'Lens upgrade selected',
        lens.type + ' · ' + formatMoney(lens.price) + ' added with your frame.'
      )
    }

    /* --------------------------------------------------------- lens model */

    function getCurrentFrameVariant() {
      var variantInput = form.querySelector('[name="id"]')
      if (!variantInput || !productData || !productData.variants) return null
      var id = String(variantInput.value)
      for (var i = 0; i < productData.variants.length; i++) {
        if (String(productData.variants[i].id) === id) return productData.variants[i]
      }
      return null
    }

    // CSV spelling is "Akrivistaa Powered Sun-lens"; older data may say
    // "Sunlens" or "Sun lens". All map to one internal group key.
    var AKRIVISTAA_RE = /akrivistaa?\s+powered\s+sun(?:\s|-|–|—)?lens/i
    var RAYBAN_AUTH_RE = /ray[ -]?ban authentic lens/i

    function getLensGroup(variant) {
      var o1 = cleanText(variant.option1)
      var t = cleanText(variant.title)
      if (AKRIVISTAA_RE.test(o1) || AKRIVISTAA_RE.test(t)) return 'Akrivistaa Powered Sunlens'
      if (RAYBAN_AUTH_RE.test(o1) || RAYBAN_AUTH_RE.test(t)) return 'Ray-Ban Authentic Lens'
      if (/single vision/i.test(o1) || /single vision/i.test(t)) return 'Single Vision'
      if (/progressive/i.test(o1) || /progressive/i.test(t)) return 'Progressive'
      if (/frame only/i.test(o1) || /frame only/i.test(t)) return 'Frame Only'
      return ''
    }

    function getLensType(variant) {
      var o2 = cleanText(variant.option2)
      var o1 = cleanText(variant.option1)
      var t = cleanText(variant.title)
      if (o2 && o2.toLowerCase() !== 'default title') return o2
      t = t.replace(/^akrivistaa?\s+powered\s+sun(?:\s|-|–|—)?lens\s*\/\s*/i, '')
        .replace(/^ray[ -]?ban authentic lens\s*\/\s*/i, '')
        .replace(/^single vision\s*\/\s*/i, '')
        .replace(/^progressive\s*\/\s*/i, '')
        .replace(/^frame only\s*\/\s*/i, '')
      if (o1) t = t.replace(o1 + ' / ', '')
      return t || o1
    }

    function makeLensOption(variant) {
      var group = getLensGroup(variant)
      var type = getLensType(variant)
      if (!group || group === 'Frame Only') return null

      var price = Number(variant.price || 0)
      var compareAt = Number(variant.compare_at_price || 0)
      var option = document.createElement('option')

      option.value = variant.id
      option.setAttribute('data-label', getDisplayLensGroupName(group) + ' - ' + type)
      option.setAttribute('data-group', group)
      option.setAttribute('data-type', type)
      option.setAttribute('data-price', price)
      option.setAttribute('data-compare-at-price', compareAt)
      option.setAttribute('data-sku', variant.sku || '')

      if (price === 0) {
        option.textContent = isSpecialLensBrand
          ? type + ' — FREE'
          : (compareAt > 0 ? type + ' - FREE Upgrade (Worth ' + formatMoney(compareAt) + ')' : type + ' - FREE')
      } else if (compareAt > price) {
        option.textContent = isSpecialLensBrand
          ? type + ' — ' + formatMoney(price) + ' (Value ' + formatMoney(compareAt) + ')'
          : type + ' - +' + formatMoney(price) + ' (Regular +' + formatMoney(compareAt) + ')'
      } else {
        option.textContent = isSpecialLensBrand ? type + ' — ' + formatMoney(price) : type + ' - +' + formatMoney(price)
      }

      return option
    }

    function getSelectedLens() {
      if (!lensSelect || !lensSelect.options || !lensSelect.options.length) {
        return { variantId: '', label: getBaseProductLabel(), group: 'Frame Only', type: getBaseProductLabel(), price: 0, compareAtPrice: 0, sku: '' }
      }
      var o = lensSelect.options[lensSelect.selectedIndex] || lensSelect.options[0]
      return {
        variantId: o.value || '',
        label: o.getAttribute('data-label') || getBaseProductLabel(),
        group: o.getAttribute('data-group') || 'Frame Only',
        type: o.getAttribute('data-type') || getBaseProductLabel(),
        price: Number(o.getAttribute('data-price') || 0),
        compareAtPrice: Number(o.getAttribute('data-compare-at-price') || 0),
        sku: o.getAttribute('data-sku') || ''
      }
    }

    function getCanonicalOptionsForGroup(group) {
      var out = []
      if (!lensSelect) return out
      Array.prototype.forEach.call(lensSelect.options, function (o) {
        if (o.value && o.getAttribute('data-group') === group) out.push(o)
      })
      return out
    }

    function selectCanonicalLens(variantId) {
      if (!lensSelect) return
      lensSelect.value = variantId || ''
      if (lensChoiceSelect) lensChoiceSelect.classList.remove('ho-input-error')
    }

    /* Only an actual ₹0 lens is ever auto-selected. A paid upgrade must always
       be chosen deliberately from the dropdown. */
    function autoSelectFreeLens(group) {
      if (!isSpecialLensBrand || group === 'Frame Only') return false
      var options = getCanonicalOptionsForGroup(group)
      for (var i = 0; i < options.length; i++) {
        if (Number(options[i].getAttribute('data-price') || 0) === 0) {
          selectCanonicalLens(options[i].value)
          if (lensChoiceSelect) lensChoiceSelect.value = options[i].value
          return true
        }
      }
      selectCanonicalLens('')
      if (lensChoiceSelect) lensChoiceSelect.value = ''
      return false
    }

    /* ------------------------------------------------------------ lens UI */

    function setLensTypeButtonState(group) {
      Array.prototype.forEach.call(lensTypeButtons, function (b) {
        var active = b.getAttribute('data-ho-lens-group') === group
        b.classList.toggle('is-active', active)
        b.setAttribute('aria-checked', active ? 'true' : 'false')
      })
    }

    function updateLensTypeAvailability() {
      Array.prototype.forEach.call(lensTypeButtons, function (b) {
        var group = b.getAttribute('data-ho-lens-group') || 'Frame Only'
        if (group === 'Frame Only') { b.disabled = false; return }
        b.disabled = !lensOptionsLoaded || getCanonicalOptionsForGroup(group).length === 0
      })
    }

    function populateVisibleLensChoice(group) {
      if (!lensChoiceSelect || !lensChoiceWrap) return

      while (lensChoiceSelect.options.length) lensChoiceSelect.remove(0)

      if (group === 'Frame Only') {
        lensChoiceWrap.hidden = true
        lensChoiceSelect.disabled = true
        return
      }

      lensChoiceWrap.hidden = false

      var groupName = getDisplayLensGroupName(group)
      var placeholder = document.createElement('option')
      placeholder.value = ''
      if (group === 'Akrivistaa Powered Sunlens') {
        placeholder.textContent = lensOptionsLoaded ? 'Select Akrivistaa Powered Sun-lens' : 'Loading Akrivistaa Powered Sun-lens options...'
      } else if (group === 'Ray-Ban Authentic Lens') {
        placeholder.textContent = lensOptionsLoaded ? 'Select a Ray-Ban Authentic Lens' : 'Loading Ray-Ban Authentic Lens options...'
      } else {
        placeholder.textContent = lensOptionsLoaded ? 'Select a ' + groupName + ' lens' : 'Loading ' + groupName + ' lenses...'
      }
      placeholder.selected = true
      placeholder.disabled = true
      lensChoiceSelect.appendChild(placeholder)

      if (lensChoiceLabel) {
        if (group === 'Akrivistaa Powered Sunlens') lensChoiceLabel.textContent = '2. Choose Akrivistaa Powered Sun-lens'
        else if (group === 'Ray-Ban Authentic Lens') lensChoiceLabel.textContent = '2. Choose Ray-Ban Authentic Lens'
        else lensChoiceLabel.textContent = isSpecialLensBrand ? 'Choose Lens' : '2. Choose Your ' + group + ' Lens'
      }

      if (!lensOptionsLoaded) { lensChoiceSelect.disabled = true; return }

      var options = getCanonicalOptionsForGroup(group)
      options.forEach(function (src) {
        var o = document.createElement('option')
        o.value = src.value
        o.textContent = src.textContent
        lensChoiceSelect.appendChild(o)
      })

      lensChoiceSelect.disabled = options.length === 0
      if (!options.length) {
        if (group === 'Akrivistaa Powered Sunlens') placeholder.textContent = 'No Akrivistaa Powered Sun-lens options available'
        else if (group === 'Ray-Ban Authentic Lens') placeholder.textContent = 'No Ray-Ban Authentic Lens options available'
        else placeholder.textContent = 'No ' + groupName + ' lenses available'
      }
    }

    function updateSpecialOfferCard(lens) {
      if (!isSpecialLensBrand || !specialOfferTitle) return

      if (!lens || !lens.variantId) {
        if (specialOfferPrice) specialOfferPrice.textContent = 'AVAILABLE'
        specialOfferTitle.textContent = 'FREE Single Vision / Progressive lens available'
        if (specialOfferCopy) specialOfferCopy.textContent = 'Choose Single Vision or Progressive and the complimentary ₹0 lens will be selected automatically.'
        return
      }

      if (lens.price === 0) {
        if (specialOfferPrice) specialOfferPrice.textContent = 'FREE'
        specialOfferTitle.textContent = lens.compareAtPrice > 0
          ? formatMoney(lens.compareAtPrice) + ' lens unlocked FREE'
          : lens.type + ' included FREE'
        if (specialOfferCopy) specialOfferCopy.textContent = 'Included with your frame. Enter your power or upload your prescription.'
        return
      }

      if (specialOfferPrice) specialOfferPrice.textContent = formatMoney(lens.price)
      specialOfferTitle.textContent = lens.compareAtPrice > lens.price
        ? formatMoney(lens.compareAtPrice) + ' lens at ' + formatMoney(lens.price) + ' · Save ' + formatMoney(getLensSavings(lens))
        : 'Lens upgrade selected'
      if (specialOfferCopy) specialOfferCopy.textContent = 'This lens will be added with the frame.'
    }

    function updatePackageSummary(lens, framePrice) {
      if (!isSpecialLensBrand || !packageSummary) return
      framePrice = Number(framePrice || 0)

      if (packageFramePrice) packageFramePrice.textContent = formatMoney(framePrice)

      if (!lens || !lens.variantId) {
        if (packageLensLabel) packageLensLabel.textContent = 'Lens'
        if (packageLensPrice) packageLensPrice.textContent = 'Not selected'
        if (packageTotal) packageTotal.textContent = formatMoney(framePrice)
        if (packageSaving) { packageSaving.hidden = true; packageSaving.textContent = '' }
        if (packageNote) packageNote.textContent = 'Frame Only selected. Choose Single Vision or Progressive to add the complimentary lens.'
        return
      }

      var saving = getLensSavings(lens)
      if (packageLensLabel) packageLensLabel.textContent = lens.type || getDisplayLensGroupName(lens.group)
      if (packageLensPrice) packageLensPrice.textContent = lens.price === 0 ? 'FREE' : '+' + formatMoney(lens.price)
      if (packageTotal) packageTotal.textContent = formatMoney(framePrice + Number(lens.price || 0))

      if (packageSaving) {
        if (saving > 0) {
          packageSaving.hidden = false
          packageSaving.textContent = lens.price === 0
            ? 'Unlocked: ' + formatMoney(lens.compareAtPrice) + ' lens included FREE.'
            : 'Unlocked: ' + formatMoney(lens.compareAtPrice) + ' lens for ' + formatMoney(lens.price) + ' — you save ' + formatMoney(saving) + '.'
        } else {
          packageSaving.hidden = true
          packageSaving.textContent = ''
        }
      }

      if (packageNote) {
        packageNote.textContent = lens.price === 0
          ? 'Frame + complimentary lens. Add your power or upload your prescription.'
          : 'Upgrade added. Add your power or upload your prescription.'
      }
    }

    function updateLensText() {
      if (!lensBox || !lensSelect) return

      var lens = getSelectedLens()
      var frameVariant = getCurrentFrameVariant()
      var framePrice = frameVariant && frameVariant.price ? Number(frameVariant.price) : 0
      var total = framePrice + lens.price
      var displayGroup = getDisplayLensGroupName(lens.group)

      if (lensFrameProperty) lensFrameProperty.value = lens.label || getBaseProductLabel()

      if (lensPrice) {
        if (!lens.variantId) {
          lensPrice.hidden = true
          lensPrice.textContent = ''
        } else {
          lensPrice.hidden = false
          lensPrice.textContent = lens.price === 0 ? 'FREE' : '+' + formatMoney(lens.price)
        }
      }

      updateSpecialOfferCard(lens)
      updatePackageSummary(lens, framePrice)

      if (!lensSummary) return

      if (!lens.variantId) {
        if (selectedLensGroup === 'Akrivistaa Powered Sunlens') {
          lensSummary.textContent = 'Power guide: If your total power (SPH + CYL) is 3.00 or below, choose 1.56 index. If your total power is above 3.00, choose 1.60 index.'
        } else if (selectedLensGroup === 'Ray-Ban Authentic Lens') {
          lensSummary.textContent = 'Select a Ray-Ban Authentic Lens option to see its price and continue.'
        } else if (selectedLensGroup !== 'Frame Only') {
          lensSummary.textContent = 'Select a ' + getDisplayLensGroupName(selectedLensGroup) + ' lens to see its price and continue.'
        } else if (isRayBanSunLensProduct) {
          lensSummary.textContent = 'Sunglass Only selected. Choose Akrivistaa Powered Sun-lens or Ray-Ban Authentic Lens to add powered lenses.'
        } else if (isSunLensProduct) {
          lensSummary.textContent = 'Sunglass Only selected. Choose Akrivistaa Powered Sun-lens to add powered Sun-lens options.'
        } else {
          lensSummary.textContent = 'Frame Only selected. You can continue with the frame or upload a prescription for reference.'
        }
        return
      }

      if (lens.price === 0) {
        lensSummary.textContent = (lens.compareAtPrice > 0
          ? 'Complimentary ' + displayGroup + ' lens included — FREE (regular ' + formatMoney(lens.compareAtPrice) + '). '
          : 'Complimentary ' + displayGroup + ' lens included — FREE. ') +
          'Frame + lens total: ' + formatMoney(total) + '.'
        return
      }

      if (lens.compareAtPrice > lens.price) {
        lensSummary.textContent = 'Premium ' + displayGroup + ' lens upgrade — regular ' +
          formatMoney(lens.compareAtPrice) + ', your price ' + formatMoney(lens.price) +
          '. You save ' + formatMoney(getLensSavings(lens)) + '. Frame + lens total: ' + formatMoney(total) + '.'
        return
      }

      lensSummary.textContent = displayGroup + ' lens selected. Lens price ' + formatMoney(lens.price) +
        ' will be added with the frame. Total: ' + formatMoney(total) + '.'
    }

    /* --------------------------------------------------------- power / Rx */

    function getPowerValueForLens(lens) {
      if (!lens || !lens.variantId || lens.group === 'Frame Only') return 'Frame Only'
      if (lens.group === 'Single Vision' || lens.group === 'Akrivistaa Powered Sunlens' || lens.group === 'Ray-Ban Authentic Lens') return 'Single Vision'
      if (lens.group === 'Progressive') return 'Progressive'
      return 'Frame Only'
    }

    function getActivePowerGroup(method, requirement) {
      if (method === 'Upload Prescription') return 'Upload Prescription'
      if (method === 'Manual Power' && requirement === 'Single Vision') return 'Single Vision Power'
      if (method === 'Manual Power' && requirement === 'Progressive') return 'Progressive Power'
      return ''
    }

    // Sunglass Only never takes a prescription; Frame Only may upload one for reference.
    function frameOnlyAllowedMethods() {
      return isSunLensProduct ? ['No Prescription'] : ['No Prescription', 'Upload Prescription']
    }

    function setPowerOptionAvailability(lens) {
      if (!powerSelect) return
      var requirement = getPowerValueForLens(lens)
      var allowed = requirement === 'Frame Only'
        ? frameOnlyAllowedMethods()
        : ['Manual Power', 'Upload Prescription']

      Array.prototype.forEach.call(powerSelect.options, function (o) {
        if (o.value === '') {
          o.disabled = true
          if (requirement === 'Single Vision') o.textContent = 'Select how you want to provide your Single Vision power'
          else if (requirement === 'Progressive') o.textContent = 'Select how you want to provide your Progressive power'
          else o.textContent = isSunLensProduct ? 'Sunglass power options' : 'Select an option'
          return
        }
        o.disabled = allowed.indexOf(o.value) === -1
        if (o.value === 'No Prescription') o.textContent = isSunLensProduct ? 'No sunglass power needed' : 'No prescription needed'
        if (o.value === 'Manual Power') {
          if (isSpecialLensBrand) o.textContent = 'Enter power now'
          else if (requirement === 'Single Vision') o.textContent = 'Add my Single Vision power'
          else if (requirement === 'Progressive') o.textContent = 'Add my Progressive power'
          else o.textContent = 'Add my power'
        }
      })

      if (powerLabel) {
        if (isSpecialLensBrand && requirement !== 'Frame Only') powerLabel.textContent = '2. Power / Prescription'
        else if (isSunLensProduct && requirement === 'Single Vision') powerLabel.textContent = '3. Add Your Sunglass Power'
        else if (requirement === 'Single Vision') powerLabel.textContent = '3. Add Your Single Vision Power'
        else if (requirement === 'Progressive') powerLabel.textContent = '3. Add Your Progressive Power'
        else powerLabel.textContent = isSunLensProduct ? '3. Sunglass Power (Optional)' : '3. Prescription (Optional)'
      }
    }

    function updatePowerFields() {
      if (!powerWrapper || !powerSelect) return

      var lens = getSelectedLens()
      var requirement = getPowerValueForLens(lens)
      var method = powerSelect.value
      var activeName = getActivePowerGroup(method, requirement)

      Array.prototype.forEach.call(powerWrapper.querySelectorAll('[data-ho-power-group]'), function (group) {
        var active = group.getAttribute('data-ho-power-group') === activeName
        group.classList.toggle('is-active', active)
        Array.prototype.forEach.call(group.querySelectorAll('input, textarea, select'), function (f) {
          f.disabled = !active
          if (!active) f.classList.remove('ho-input-error')
        })
      })

      if (powerError) powerError.style.display = 'none'
      if (powerRequirementProperty) powerRequirementProperty.value = requirement

      if (powerStatus) {
        var required = requirement !== 'Frame Only'
        powerStatus.textContent = required ? 'Required' : (isSunLensProduct ? 'Not Needed' : 'Optional')
        powerStatus.classList.toggle('is-required', required)
      }

      if (powerDetailsProperty) {
        if (method === 'No Prescription') powerDetailsProperty.value = isSunLensProduct ? 'No power required (Sunglass Only)' : 'No prescription supplied (Frame Only)'
        else if (method === 'Upload Prescription') powerDetailsProperty.value = requirement + ' prescription uploaded on product page'
        else if (method === 'Manual Power') powerDetailsProperty.value = requirement + ' power entered on product page'
        else powerDetailsProperty.value = 'Prescription method not selected'
      }

      if (powerHelp) {
        if (requirement === 'Frame Only' && method === 'No Prescription') {
          powerHelp.textContent = isSunLensProduct
            ? 'No prescription is needed for Sunglass Only. If you need powered sunglasses, choose a Powered Sun-lens above, then add or upload your prescription.'
            : 'Prescription is optional for Frame Only. You can continue without one or upload it for reference.'
        } else if (method === 'Upload Prescription') {
          powerHelp.textContent = 'Upload a clear JPG, PNG or PDF prescription before continuing.'
        } else if (method === 'Manual Power' && requirement === 'Single Vision') {
          powerHelp.textContent = isSunLensProduct
            ? 'Enter your Single Vision sunglass power for both eyes. SPH is required; CYL, Axis and PD can be added when applicable. Final Sun-lens feasibility will be confirmed after purchase.'
            : 'Enter the Single Vision power for both eyes. SPH is required; CYL, Axis and PD can be added when applicable.'
        } else if (method === 'Manual Power' && requirement === 'Progressive') {
          powerHelp.textContent = 'Enter the Progressive power for both eyes. SPH and ADD are required; CYL, Axis and PD can be added when applicable.'
        } else if (requirement !== 'Frame Only') {
          powerHelp.textContent = isSunLensProduct
            ? 'Choose “Add my Single Vision power” or “Upload my Prescription”. Final Sun-lens feasibility will be confirmed after purchase.'
            : 'Choose whether to enter your power now or upload your prescription.'
        } else {
          powerHelp.textContent = isSunLensProduct
            ? 'No prescription is needed for Sunglass Only. Choose a Powered Sun-lens above only if you need prescription sunglasses.'
            : 'Prescription is optional for Frame Only.'
        }
      }
    }

    function syncPowerWithLens(forceReset) {
      if (!powerSelect) return

      var lens = getSelectedLens()
      var requirement = getPowerValueForLens(lens)
      var changed = lastLensRequirement !== requirement

      setPowerOptionAvailability(lens)

      if (requirement === 'Frame Only') {
        if (forceReset || changed || frameOnlyAllowedMethods().indexOf(powerSelect.value) === -1) {
          powerSelect.value = 'No Prescription'
        }
      } else if (forceReset || changed || ['Manual Power', 'Upload Prescription'].indexOf(powerSelect.value) === -1) {
        powerSelect.value = ''
      }

      lastLensRequirement = requirement
      updatePowerFields()

      var waiting = selectedLensGroup !== 'Frame Only' &&
        (!lens || !lens.variantId || lens.group !== selectedLensGroup)

      powerSelect.disabled = waiting

      if (waiting) {
        powerSelect.value = ''
        if (powerLabel) powerLabel.textContent = isSunLensProduct ? '3. Sunglass Power' : '3. Prescription'
        if (powerStatus) { powerStatus.textContent = 'Select Lens'; powerStatus.classList.remove('is-required') }
        if (powerHelp) {
          powerHelp.textContent = 'Choose your ' + getDisplayLensGroupName(selectedLensGroup) + ' lens first. ' +
            (isSunLensProduct
              ? 'Sunglass power options will appear after the lens is selected.'
              : 'Prescription options will appear after the lens is selected.')
        }
        if (powerWrapper) {
          Array.prototype.forEach.call(powerWrapper.querySelectorAll('[data-ho-power-group]'), function (group) {
            group.classList.remove('is-active')
            Array.prototype.forEach.call(group.querySelectorAll('input, textarea, select'), function (f) {
              f.disabled = true
              f.classList.remove('ho-input-error')
            })
          })
        }
      }
    }

    function setLensGroup(group, forceReset) {
      if (VALID_GROUPS.indexOf(group) === -1) group = 'Frame Only'

      var changed = selectedLensGroup !== group
      selectedLensGroup = group
      setLensTypeButtonState(group)

      if (rayBanDeliveryNotice) rayBanDeliveryNotice.hidden = group !== 'Ray-Ban Authentic Lens'

      if (group === 'Frame Only') {
        selectCanonicalLens('')
        populateVisibleLensChoice(group)
        hideNotice()
      } else {
        if (forceReset || changed) selectCanonicalLens('')
        populateVisibleLensChoice(group)
        if (isSpecialLensBrand && (changed || forceReset)) autoSelectFreeLens(group)
      }

      updateLensText()
      syncPowerWithLens(changed || forceReset)

      if (isSpecialLensBrand && changed && group !== 'Frame Only') {
        var lens = getSelectedLens()
        if (lens && lens.variantId && lens.group === group) showLensSelectionNotice(lens)
      }
    }

    /* ------------------------------------------------------ lens loading */

    function loadLensOptions() {
      if (!lensBox || !lensSelect) return

      while (lensSelect.options.length > 1) lensSelect.remove(1)

      // Every add-on product is fetched independently: one missing source must
      // not disable the others (e.g. Ray-Ban page with only sunlens-add-on live).
      var requests = lensProductHandles.map(function (handle) {
        return fetch(root + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) {
            if (!r.ok) throw new Error('Lens product not found: ' + handle)
            return r.json()
          })
          .then(function (product) { return { handle: handle, product: product } })
          .catch(function (err) {
            if (window.console) console.warn('Lens source unavailable:', handle, err)
            return null
          })
      })

      Promise.all(requests)
        .then(function (sources) {
          var valid = sources.filter(function (src) { return src && src.product && src.product.variants })
          if (!valid.length) throw new Error('No lens add-on products could be loaded: ' + lensProductHandles.join(', '))

          var buckets = {}
          var order = ['Single Vision', 'Progressive', 'Akrivistaa Powered Sunlens', 'Ray-Ban Authentic Lens']
          order.forEach(function (g) {
            var og = document.createElement('optgroup')
            og.label = getDisplayLensGroupName(g)
            buckets[g] = og
          })

          var seen = {}

          valid.forEach(function (src) {
            src.product.variants.forEach(function (variant) {
              // Inventory 0 with policy "continue" still reports available: true.
              if (variant.available === false) return

              var option = makeLensOption(variant)
              if (!option) return

              var group = option.getAttribute('data-group') || ''

              // Hard source ownership for powered sunglasses.
              if (src.handle === 'sunlens-add-on' && group !== 'Akrivistaa Powered Sunlens') return
              if (src.handle === 'rayban-sunlens-add-on' && group !== 'Ray-Ban Authentic Lens') return

              // Only groups that this product actually offers.
              if (isSunLensProduct) {
                if (group !== 'Akrivistaa Powered Sunlens' && group !== 'Ray-Ban Authentic Lens') return
                if (group === 'Ray-Ban Authentic Lens' && !isRayBanSunLensProduct) return
              } else if (group !== 'Single Vision' && group !== 'Progressive') {
                return
              }

              // Semantic dedupe: SKU if present, else group + type + price.
              var sku = (option.getAttribute('data-sku') || '').trim().toLowerCase()
              var type = (option.getAttribute('data-type') || '').trim().toLowerCase()
              var price = option.getAttribute('data-price') || '0'
              var key = sku ? group + '|sku|' + sku : group + '|type|' + type + '|price|' + price
              if (seen[key]) return
              seen[key] = true

              if (buckets[group]) buckets[group].appendChild(option)
            })
          })

          var any = false
          order.forEach(function (g) {
            if (buckets[g].children.length) { lensSelect.appendChild(buckets[g]); any = true }
          })

          if (!any) {
            throw new Error(isSunLensProduct
              ? 'No Akrivistaa Powered Sun-lens / Ray-Ban Authentic Lens variants found.'
              : 'No Single Vision / Progressive lens variants found.')
          }

          lensOptionsLoaded = true
          lensSelect.disabled = false
          updateLensTypeAvailability()

          selectedLensGroup = 'Frame Only'
          setLensTypeButtonState(selectedLensGroup)
          selectCanonicalLens('')
          populateVisibleLensChoice(selectedLensGroup)
          if (rayBanDeliveryNotice) rayBanDeliveryNotice.hidden = true
          updateLensText()
          syncPowerWithLens(true)
        })
        .catch(function () {
          lensOptionsLoaded = false
          lensSelect.disabled = true
          updateLensTypeAvailability()
          if (lensChoiceSelect) lensChoiceSelect.disabled = true
          if (lensSummary) {
            lensSummary.textContent =
              (isRayBanSunLensProduct
                ? 'Powered Sun-lens / Ray-Ban Authentic Lens'
                : (isSunLensProduct ? 'Powered Sun-lens' : 'Lens')) +
              ' options are currently unavailable. Check that these add-on products are Active and published to the Online Store: ' +
              lensProductHandles.join(', ') + '.'
          }
        })
    }

    /* --------------------------------------------------------- validation */

    function validateLensSelection() {
      if (!lensBox || selectedLensGroup === 'Frame Only') return true

      var lens = getSelectedLens()
      if (lens && lens.variantId && lens.group === selectedLensGroup) {
        if (lensChoiceSelect) lensChoiceSelect.classList.remove('ho-input-error')
        return true
      }

      if (lensChoiceSelect) {
        lensChoiceSelect.classList.add('ho-input-error')
        lensChoiceSelect.focus()
      }
      if (lensSummary) lensSummary.textContent = 'Please select a ' + getDisplayLensGroupName(selectedLensGroup) + ' lens before continuing.'
      return false
    }

    function validatePowerForm() {
      if (!powerWrapper || !powerSelect) return true

      var lens = getSelectedLens()
      var requirement = getPowerValueForLens(lens)
      var method = powerSelect.value
      var firstInvalid = null

      Array.prototype.forEach.call(powerWrapper.querySelectorAll('.ho-input-error'), function (f) {
        f.classList.remove('ho-input-error')
      })

      if (requirement === 'Frame Only') {
        if (frameOnlyAllowedMethods().indexOf(method) === -1) {
          powerSelect.value = 'No Prescription'
          updatePowerFields()
          return true
        }
        if (method === 'No Prescription') {
          if (powerError) powerError.style.display = 'none'
          return true
        }
      } else if (method !== 'Manual Power' && method !== 'Upload Prescription') {
        if (powerError) {
          powerError.textContent = 'Please enter your power or upload your prescription before continuing.'
          powerError.style.display = 'block'
        }
        powerSelect.focus()
        return false
      }

      var activeName = getActivePowerGroup(method, requirement)
      var activeGroup = activeName ? powerWrapper.querySelector('[data-ho-power-group="' + activeName + '"]') : null
      if (!activeGroup) return true

      Array.prototype.forEach.call(activeGroup.querySelectorAll('[data-ho-required="true"]'), function (field) {
        if (field.type === 'file') {
          var has = field.files && field.files.length > 0
          var ok = has && /\.(jpg|jpeg|png|pdf)$/i.test(field.files[0].name || '')
          if (!ok) { field.classList.add('ho-input-error'); if (!firstInvalid) firstInvalid = field }
        } else if (!field.value || !field.value.trim()) {
          field.classList.add('ho-input-error')
          if (!firstInvalid) firstInvalid = field
        }
      })

      if (firstInvalid) {
        if (powerError) {
          powerError.textContent = method === 'Upload Prescription'
            ? 'Please upload a valid JPG, JPEG, PNG or PDF prescription before continuing.'
            : 'Please complete all required prescription fields before continuing.'
          powerError.style.display = 'block'
        }
        activeGroup.classList.add('is-active')
        firstInvalid.focus()
        return false
      }

      if (powerError) powerError.style.display = 'none'
      return true
    }

    /* --------------------------------------------------------------- cart */

    function getQuantity() {
      var q = quantityInput ? Number(quantityInput.value || 1) : 1
      if (!q || q < 1) q = 1
      return q
    }

    function clampQuantity() {
      if (!quantityInput) return
      var q = Number(quantityInput.value || 1)
      if (!q || q < 1) q = 1
      if (q > MAX_CART_QTY) q = MAX_CART_QTY
      quantityInput.value = q
    }

    function isLensAddonCartItem(item) {
      if (!item) return false
      var h = item.handle || item.product_handle
      if (LENS_ADDON_HANDLES.indexOf(h) !== -1) return true
      return !!(item.properties && item.properties._lens_addon === 'true')
    }

    function collectLineItemProperties() {
      var properties = {}
      new FormData(form).forEach(function (value, key) {
        if (key.indexOf('properties[') === 0 && key.indexOf(']') > -1) {
          var name = key.replace('properties[', '').replace(']', '')
          if (value !== '' && value !== null && typeof value !== 'object') properties[name] = value
        }
      })
      return properties
    }

    function setHiddenProperty(name, value) {
      var input = form.querySelector('input[type="hidden"][name="properties[' + name + ']"]')
      if (!input) {
        input = document.createElement('input')
        input.type = 'hidden'
        input.name = 'properties[' + name + ']'
        form.appendChild(input)
      }
      input.value = value || ''
    }

    function makeConfigurationKey() {
      return 'ho-' + Date.now() + '-' + Math.random().toString(36).slice(2, 9)
    }

    function buildCartItems(configurationKey) {
      var variantInput = form.querySelector('[name="id"]')
      if (!variantInput || !variantInput.value) return null

      var lens = getSelectedLens()
      var frameVariant = getCurrentFrameVariant()
      var quantity = getQuantity()
      var method = powerSelect ? powerSelect.value : 'No Prescription'
      var requirement = getPowerValueForLens(lens)
      var details = powerDetailsProperty
        ? powerDetailsProperty.value
        : (isSunLensProduct ? 'No power required (Sunglass Only)' : 'No prescription supplied (Frame Only)')

      var frameData = {
        variantId: Number(variantInput.value),
        variantTitle: frameVariant && frameVariant.title && frameVariant.title !== 'Default Title' ? frameVariant.title : '',
        sku: frameVariant && frameVariant.sku ? frameVariant.sku : ''
      }

      var frameProperties = collectLineItemProperties()
      frameProperties['Lens Option'] = lens.variantId ? lens.label : getBaseProductLabel()
      frameProperties['Prescription Method'] = method
      frameProperties['Power Requirement'] = requirement
      frameProperties['Power Details'] = details
      frameProperties['Prescription Status'] = getPrescriptionStatusText(method)
      frameProperties['Lens Offer'] = getLensOfferText(lens)
      if (isSunLensProduct && lens.variantId) {
        frameProperties['Lens Confirmation'] = 'Final powered Sun-lens feasibility will be confirmed after purchase, subject to technical criteria.'
        frameProperties['_sunlens_confirmation_required'] = 'true'
        if (isRayBanSunLensProduct) frameProperties['_rayban_standard_sunglass_lens'] = 'true'
      }
      frameProperties['_configuration_key'] = configurationKey
      if (frameData.variantTitle) frameProperties['Frame Variant'] = frameData.variantTitle
      if (frameData.sku) frameProperties['Frame SKU'] = frameData.sku

      var items = [{ id: frameData.variantId, quantity: quantity, properties: frameProperties }]

      if (lens.variantId) {
        items.push({
          id: Number(lens.variantId),
          quantity: quantity,
          properties: {
            _lens_addon: 'true',
            _lens_category: lens.group,
            _lens_type: lens.type,
            _lens_for: CONFIG.productTitle,
            _frame_variant_id: String(frameData.variantId),
            _frame_variant: frameData.variantTitle,
            _frame_sku: frameData.sku,
            _lens_sku: lens.sku,
            _lens_offer: getLensOfferText(lens),
            _lens_regular_price: String(lens.compareAtPrice || 0),
            _lens_offer_price: String(lens.price || 0),
            _power_requirement: requirement,
            _prescription_method: method,
            _prescription_status: getPrescriptionStatusText(method),
            _sunlens_confirmation_required: isSunLensProduct ? 'true' : 'false',
            _rayban_standard_sunglass_lens: isRayBanSunLensProduct ? 'true' : 'false',
            _configuration_key: configurationKey
          }
        })
      }

      return {
        items: items,
        quantity: quantity,
        lens: lens,
        frameData: frameData,
        method: method,
        requirement: requirement,
        details: details,
        configurationKey: configurationKey
      }
    }

    function isUploadSelected() {
      return !!(powerSelect && powerSelect.value === 'Upload Prescription')
    }

    function hasContactLensUpload() {
      var input = form.querySelector('[data-ho-cl-upload-input]')
      var method = form.querySelector('[data-ho-cl-method]')
      return !!(method && method.value === 'Upload Prescription' && input && !input.disabled && input.files && input.files.length)
    }

    /* A file line-item property must go through a real multipart form POST.
       Sending it via /cart/add.js leaves Shopify with the browser-safe
       C:\fakepath\... value instead of the uploaded file. */
    function nativeSubmitWithFile() {
      isNativeUploadSubmitting = true
      form.setAttribute('method', 'post')
      form.setAttribute('enctype', 'multipart/form-data')
      form.action = root + 'cart/add'

      var returnTo = form.querySelector('input[name="return_to"]')
      if (!returnTo) {
        returnTo = document.createElement('input')
        returnTo.type = 'hidden'
        returnTo.name = 'return_to'
        form.appendChild(returnTo)
      }
      returnTo.value = goToCheckoutMode ? root + 'checkout' : root + 'cart'

      // Bypasses every submit listener, including Gem's.
      HTMLFormElement.prototype.submit.call(form)
    }

    function addLensOnly(payload) {
      var lens = payload.lens
      if (!lens || !lens.variantId) return Promise.resolve()

      return fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{
            id: Number(lens.variantId),
            quantity: payload.quantity,
            properties: {
              _lens_addon: 'true',
              _lens_category: lens.group,
              _lens_type: lens.type,
              _lens_for: CONFIG.productTitle,
              _frame_variant_id: String(payload.frameData.variantId),
              _lens_sku: lens.sku,
              _lens_offer: getLensOfferText(lens),
              _power_requirement: payload.requirement,
              _prescription_method: payload.method,
              _sunlens_confirmation_required: isSunLensProduct ? 'true' : 'false',
              _rayban_standard_sunglass_lens: isRayBanSunLensProduct ? 'true' : 'false',
              _configuration_key: payload.configurationKey
            }
          }]
        })
      })
    }

    var buyNowButton = null

    function setLoading(isLoading) {
      if (addButton) {
        addButton.disabled = isLoading
        addButton.classList.toggle('btn--loading', isLoading)
      }
      if (buyNowButton) {
        if (!buyNowButton.dataset.originalText) buyNowButton.dataset.originalText = buyNowButton.textContent.trim()
        buyNowButton.disabled = isLoading
        buyNowButton.textContent = isLoading && goToCheckoutMode ? 'Processing...' : buyNowButton.dataset.originalText
      }
    }

    /* Shopify's dynamic checkout button posts only the frame variant, so the
       lens line and prescription would be lost. Replace it with our own. */
    function installBuyNowButton() {
      var container = form.querySelector('[data-dynamic-checkout-container]')
      if (!container || form.querySelector('[data-ho-buy-now-with-lens]')) return

      container.style.display = 'none'
      container.setAttribute('aria-hidden', 'true')

      var wrap = document.createElement('div')
      wrap.className = 'shopify-payment-button ho-buy-now-wrap'
      buyNowButton = document.createElement('button')
      buyNowButton.type = 'button'
      buyNowButton.className = 'shopify-payment-button__button shopify-payment-button__button--unbranded ho-buy-now-btn'
      buyNowButton.setAttribute('data-ho-buy-now-with-lens', '')
      buyNowButton.textContent = isSpecialLensBrand ? 'Buy complete eyewear now' : 'Buy it now'
      if (addButton && addButton.disabled) buyNowButton.disabled = true
      wrap.appendChild(buyNowButton)
      container.parentNode.insertBefore(wrap, container.nextSibling)

      buyNowButton.addEventListener('click', function (e) { handleSubmit(e, true) })
    }

    function showAddedNotice(payload) {
      if (isSpecialLensBrand && selectedLensGroup === 'Frame Only') { hideNotice(); return }

      var lens = payload.lens
      var title = 'Eyewear package added to cart'
      if (lens && lens.variantId && lens.price === 0) title = 'Frame + free lens added'
      else if (lens && lens.variantId && lens.compareAtPrice > lens.price) title = 'Frame + lens upgrade added'

      var parts = []
      if (lens && lens.variantId) parts.push(lens.type + ' — ' + getLensOfferText(lens))
      parts.push(getPrescriptionStatusText(payload.method))
      showNotice(title, parts.join('. ') + '.')
    }

    function clearCartIfBuyNow() {
      if (!goToCheckoutMode) return Promise.resolve()
      return fetch(root + 'cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } })
        .catch(function () {})
    }

    function handleSubmit(event, buyNow) {
      if (isNativeUploadSubmitting) return

      if (event) {
        event.preventDefault()
        event.stopPropagation()
        event.stopImmediatePropagation()
      }

      goToCheckoutMode = buyNow === true || CONFIG.afterAdd === 'checkout'

      clampQuantity()

      if (isContactLens) {
        if (!validateContactLensPower(event)) return
        if (hasContactLensUpload()) {
          setLoading(true)
          clearCartIfBuyNow().then(nativeSubmitWithFile)
          return
        }
      }

      if (showLensSelector) {
        if (!validateLensSelection()) return
        if (!validatePowerForm()) return
      }

      var payload = buildCartItems(makeConfigurationKey())
      if (!payload) return

      setLoading(true)

      var work

      if (showLensSelector && isUploadSelected()) {
        // Lens line goes via ajax, then the frame + file goes native.
        work = clearCartIfBuyNow().then(function () { return addLensOnly(payload) }).then(function () {
          setHiddenProperty('Lens Option', payload.lens.label || getBaseProductLabel())
          setHiddenProperty('Power Requirement', payload.requirement)
          setHiddenProperty('Power Details', payload.details)
          setHiddenProperty('_configuration_key', payload.configurationKey)
          nativeSubmitWithFile()
        })
      } else {
        work = clearCartIfBuyNow().then(function () {
          return fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: payload.items })
          })
        })
          .then(function (r) {
            if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Unable to add product.') })
            return r.json()
          })
          .then(function () {
            showAddedNotice(payload)
            return new Promise(function (res) { setTimeout(res, 700) })
          })
          .then(function () {
            window.location.href = goToCheckoutMode ? root + 'checkout' : root + 'cart'
          })
      }

      work.catch(function (err) {
        if (powerError) {
          powerError.textContent = err.message || 'Something went wrong. Please try again.'
          powerError.style.display = 'block'
        }
      }).then(function () {
        if (!isNativeUploadSubmitting) setLoading(false)
      })
    }

    /* ------------------------------------------- contact lens power panel */

    var clWrapper = document.getElementById('HOCLPower-' + SECTION_ID)

    function validateContactLensPower() { return true }

    if (clWrapper) {
      clWrapper.removeAttribute('open')
      clWrapper.open = false

      var clMethod = clWrapper.querySelector('[data-ho-cl-method]')
      var clManual = clWrapper.querySelector('[data-ho-cl-manual-panel]')
      var clUploadPanel = clWrapper.querySelector('[data-ho-cl-upload-panel]')
      var clUpload = clWrapper.querySelector('[data-ho-cl-upload-input]')
      var clUploadName = clWrapper.querySelector('[data-ho-cl-upload-name]')
      var clTypeInput = clWrapper.querySelector('[data-ho-cl-type]')
      var clTypeLabel = clWrapper.querySelector('[data-ho-cl-type-label]')
      var clType = clWrapper.getAttribute('data-ho-cl-prescription-type') || 'Spherical'
      var clSph = clWrapper.querySelectorAll('[data-ho-cl-sph]')
      var clCyl = clWrapper.querySelectorAll('[data-ho-cl-cyl]')
      var clAxis = clWrapper.querySelectorAll('[data-ho-cl-axis]')
      var clToric = clWrapper.querySelectorAll('[data-ho-cl-toric]')
      var clSummary = clWrapper.querySelector('[data-ho-cl-summary]')
      var clFooter = clWrapper.querySelector('[data-ho-cl-footer-note]')
      var clError = clWrapper.querySelector('[data-ho-cl-error]')

      var hasPowerInfo = /\b(power|powers|sph|sphere|spherical)\b/i.test(
        String(CONFIG.productDescription || '').replace(/\u00a0/g, ' ')
      )

      function clTypeText() {
        if (clType === 'Toric') return 'Toric / Astigmatism'
        if (clType === 'Multifocal') return 'Multifocal'
        return 'Spherical / Regular'
      }

      if (clTypeInput) clTypeInput.value = clType
      if (clTypeLabel) clTypeLabel.textContent = clTypeText()

      Array.prototype.forEach.call(clWrapper.querySelectorAll('[data-ho-cl-sph-label]'), function (l) {
        l.textContent = clType === 'Multifocal' ? 'Multifocal Power / SPH' : 'SPH / Power'
      })

      function signed(v) {
        var n = Number(v)
        if (Math.abs(n) < 0.001) return '0.00 / Plano'
        return (n > 0 ? '+' : '') + n.toFixed(2)
      }

      function addOpt(select, value, label) {
        var o = document.createElement('option')
        o.value = value
        o.textContent = label
        select.appendChild(o)
      }

      // Description mentions power/SPH -> +9.00 to -9.00, else the wider fallback.
      Array.prototype.forEach.call(clSph, function (select) {
        var max = Math.round((hasPowerInfo ? 9 : 10) * 4)
        var min = Math.round((hasPowerInfo ? -9 : -20) * 4)
        for (var i = max; i >= min; i--) addOpt(select, (i / 4).toFixed(2), signed(i / 4))
      })

      Array.prototype.forEach.call(clCyl, function (s) {
        for (var i = -1; i >= -24; i--) addOpt(s, (i / 4).toFixed(2), (i / 4).toFixed(2))
      })

      Array.prototype.forEach.call(clAxis, function (s) {
        for (var a = 1; a <= 180; a++) addOpt(s, String(a), a + '°')
      })

      function clClearErrors() {
        Array.prototype.forEach.call(clWrapper.querySelectorAll('.ho-cl-input-error'), function (f) {
          f.classList.remove('ho-cl-input-error')
        })
        if (clError) { clError.classList.remove('is-active'); clError.textContent = '' }
      }

      function clShowError(message, field) {
        clWrapper.open = true
        if (field) { field.classList.add('ho-cl-input-error'); try { field.focus() } catch (e) {} }
        if (clError) { clError.textContent = message; clError.classList.add('is-active') }
      }

      function clIsUpload() { return !!(clMethod && clMethod.value === 'Upload Prescription') }
      function clIsToric() { return clType === 'Toric' }

      function clUpdateToric() {
        var show = !clIsUpload() && clIsToric()
        Array.prototype.forEach.call(clToric, function (group) {
          group.hidden = !show
          Array.prototype.forEach.call(group.querySelectorAll('select'), function (f) {
            f.disabled = !show
            if (!show) { f.value = ''; f.classList.remove('ho-cl-input-error') }
          })
        })

        if (!clFooter) return
        var range = hasPowerInfo ? ' The SPH dropdown runs +9.00 to -9.00.' : ''
        if (clIsToric()) clFooter.textContent = 'Toric / Astigmatism: select SPH, CYL and Axis for every eye you want to order.' + range
        else if (clType === 'Multifocal') clFooter.textContent = 'Multifocal: select the Multifocal Power / SPH for the eye(s) you want to order.' + range
        else clFooter.textContent = 'Spherical / Regular: select SPH / Power for the eye(s) you want to order.' + range
      }

      function clUpdateSummary() {
        if (!clSummary) return
        if (clIsUpload()) {
          clSummary.textContent = clUpload && clUpload.files && clUpload.files.length
            ? 'Prescription uploaded · ' + clUpload.files[0].name
            : 'Upload prescription selected · choose a JPG, JPEG, PNG or PDF'
          return
        }
        var r = clWrapper.querySelector('[data-ho-cl-sph][data-ho-cl-side="R"]')
        var l = clWrapper.querySelector('[data-ho-cl-sph][data-ho-cl-side="L"]')
        if ((!r || !r.value) && (!l || !l.value)) {
          clSummary.textContent = clTypeText() + ' · Select power for at least one eye'
          return
        }
        var parts = [clTypeText()]
        if (r && r.value) parts.push('R ' + signed(r.value))
        if (l && l.value) parts.push('L ' + signed(l.value))
        clSummary.textContent = parts.join('  •  ')
      }

      function clUpdateMethod() {
        var upload = clIsUpload()
        clClearErrors()
        if (clUploadPanel) clUploadPanel.hidden = !upload
        if (clManual) clManual.hidden = upload

        if (clManual) {
          Array.prototype.forEach.call(clManual.querySelectorAll('input, select, textarea'), function (f) {
            if (f.hasAttribute('data-ho-cl-always-enabled')) { f.disabled = false; return }
            f.disabled = upload
          })
        }

        if (clUpload) {
          clUpload.disabled = !upload
          if (!upload) { clUpload.value = ''; if (clUploadName) clUploadName.textContent = 'No file selected' }
        }

        clUpdateToric()
        clUpdateSummary()
      }

      function clValidateToricEye(eye) {
        if (!eye) return null
        var sph = eye.querySelector('[data-ho-cl-sph]')
        if (!sph || !sph.value) return null
        var cyl = eye.querySelector('[data-ho-cl-cyl]')
        var axis = eye.querySelector('[data-ho-cl-axis]')
        if (!cyl || !cyl.value) return { field: cyl || sph, message: 'Please select CYL for every Toric eye where SPH / Power has been selected.' }
        if (!axis || !axis.value) return { field: axis || sph, message: 'Please select Axis for every Toric eye where SPH / Power has been selected.' }
        return null
      }

      validateContactLensPower = function () {
        clClearErrors()

        if (clIsUpload()) {
          var has = clUpload && clUpload.files && clUpload.files.length
          var ok = has && /\.(jpg|jpeg|png|pdf)$/i.test(clUpload.files[0].name || '')
          if (ok) return true
          clShowError('Please upload a valid JPG, JPEG, PNG or PDF prescription before adding this contact lens to cart.', clUpload)
          return false
        }

        var r = clWrapper.querySelector('[data-ho-cl-sph][data-ho-cl-side="R"]')
        var l = clWrapper.querySelector('[data-ho-cl-sph][data-ho-cl-side="L"]')

        if ((!r || !r.value) && (!l || !l.value)) {
          clShowError('Please select SPH / Power for at least one eye before adding this contact lens to cart.', r || l)
          return false
        }

        if (clIsToric()) {
          var err = clValidateToricEye(clWrapper.querySelector('[data-ho-cl-eye="right"]')) ||
            clValidateToricEye(clWrapper.querySelector('[data-ho-cl-eye="left"]'))
          if (err) { clShowError(err.message, err.field); return false }
        }

        return true
      }

      if (clMethod) clMethod.addEventListener('change', clUpdateMethod)

      Array.prototype.forEach.call(clWrapper.querySelectorAll('select'), function (f) {
        f.addEventListener('change', function () {
          f.classList.remove('ho-cl-input-error')
          if (clError) clError.classList.remove('is-active')
          clUpdateSummary()
        })
      })

      if (clUpload) {
        clUpload.addEventListener('change', function () {
          clUpload.classList.remove('ho-cl-input-error')
          if (clUploadName) {
            clUploadName.textContent = clUpload.files && clUpload.files.length ? clUpload.files[0].name : 'No file selected'
          }
          if (clError) clError.classList.remove('is-active')
          clUpdateSummary()
        })
      }

      clUpdateMethod()
    }

    /* ------------------------------------------------------------ wire up */

    if (!showLensSelector && !isContactLens) return

    // Capture phase: always runs before <block-buy-buttons>'s bubble listener.
    form.addEventListener('submit', function (e) { handleSubmit(e, false) }, true)
    installBuyNowButton()

    if (quantityInput) {
      quantityInput.setAttribute('max', String(MAX_CART_QTY))
      quantityInput.addEventListener('change', clampQuantity)
      quantityInput.addEventListener('blur', clampQuantity)
    }

    Array.prototype.forEach.call(lensTypeButtons, function (button) {
      button.addEventListener('click', function () {
        setLensGroup(button.getAttribute('data-ho-lens-group') || 'Frame Only', false)
      })
    })

    if (lensChoiceSelect) {
      lensChoiceSelect.addEventListener('change', function () {
        selectCanonicalLens(lensChoiceSelect.value)
        updateLensText()
        syncPowerWithLens(false)
        if (isSpecialLensBrand) showLensSelectionNotice(getSelectedLens())
      })
    }

    if (powerSelect) powerSelect.addEventListener('change', updatePowerFields)

    // Gem's variant picker dispatches a namespaced event; the plain change
    // listener is a fallback for the hidden id input.
    document.addEventListener('variant:change:' + SECTION_ID + ':' + CONFIG.productId, function () {
      setTimeout(function () {
        updateLensText()
        if (buyNowButton && addButton) buyNowButton.disabled = addButton.disabled
      }, 50)
    })

    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id') setTimeout(updateLensText, 50)
    })

    if (showLensSelector) {
      setLensTypeButtonState(selectedLensGroup)
      updateLensTypeAvailability()
      populateVisibleLensChoice(selectedLensGroup)
      syncPowerWithLens(true)
      loadLensOptions()
    }
  })
})()
